import styled from 'styled-components';
import { getThemeColor } from 'utils/styled';
import { MenuListStyleProps } from './types';

const defaultStyle = `
  padding: 15px;
`;

const comfortableStyles = `
  padding: 10px;
`;

const compactStyle = `
  padding: 6px;
`;

const densityStyles = {
  default: defaultStyle,
  comfortable: comfortableStyles,
  compact: compactStyle,
};

export const MenuListRoot = styled.ul<MenuListStyleProps>`
  color: ${getThemeColor('d1')};
  background-color: ${getThemeColor('l2')};
  list-style: none;
  ${({ $density }) => densityStyles[$density]}
  margin: 0;

  &:focus-visible {
    outline: none;
  }
`;
